import { useState, useCallback } from 'react';

export const useImagePreview = () => {
  const [previewImage, setPreviewImage] = useState('');

  const handleEditorClickEvent = useCallback((target: HTMLElement | null) => {
    if (target && target.tagName === 'IMG') {
      const element = target as HTMLImageElement;
      setPreviewImage(element.src);
    }
  }, []);

  const handleClosePreview = useCallback(() => {
    setPreviewImage('');
  }, []);

  return {
    previewImage,
    handleEditorClickEvent,
    handleClosePreview,
  };
};
